import React, { useState, useEffect } from "react";


import Table from "react-bootstrap/Table";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const ExpertCatReportSub = (props) => {
    const [experts, setExperts] = useState([]);
    const [allExperts, setAllExperts] = useState([]);
    const regions = ["Swansea", "Cardiff", "Bristol", "Birmingham", "Richmond"]

    useEffect(() => {
        apiGet(`intranetreports/getexpertsbysubservice/?table=${props.tablename}`).then(res => {
            res.json().then(data => {
                //console.log(data)
                setAllExperts(data.allexperts)
              let experts = data.subexperts;
              setExperts(experts.filter((expert) => {
                const exp = data.allexperts.find(x => x.id === expert.id)
                //console.log(exp)
                if (exp && exp.published && exp[props.tablename]){
                    return true;
                }else{
                    return false;
                }
                
              }))
            })
          })
      }, [])
    return(
        <>
            <h4>Service Total: {experts.length}</h4>
            <Table>
                <tr>
                    <th>
                    
                    </th>
                    {regions.map(region => { return <th>{region}</th>

                    })}
                    
                </tr>
                
                {
                    Object.entries(props.subservices).map(([key, value]) => {
                        return (
                            
                            <tr>
                                <td>
                                    {value}
                                </td>
                                {regions.map(region => {
                                    return ( <td>{
                                        experts.filter((expert) => {
                                            const exp = allExperts.find(x => x.id === expert.id)
                                            console.log(exp)
                                            if (exp && exp.location === region && expert[key]){
                                                return true;
                                            }else{
                                                return false;
                                            }
                                        }).length
                                        }</td>)
                                })}
                                
                               
                            </tr>
                        )
                    })
                }
                <tr style={{fontWeight: "bold"}}>
                    <td>Total</td>
                    {regions.map(region => {
                        return ( <td>{
                            experts.filter((expert) => {
                                const exp = allExperts.find(x => x.id === expert.id)
                                console.log(exp)
                                if (exp && exp.location === region){
                                    return true;
                                }else{
                                    return false;
                                }
                            }).length
                            }</td>)
                    })}
                    
                </tr>
                
            </Table>
        </>
    )
}

export default ExpertCatReportSub;